import ChalkySticks from '@chalkysticks/sdk';
import { Capacitor } from '@capacitor/core';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { StatusBar } from '@capacitor/status-bar';

/**
 * Whether native manager has been initialized
 *
 * @type boolean
 */
let hasInitialized: boolean = false;

/**
 * Initialize native features (StatusBar and Orientation).
 *
 * @return Promise<void>
 */
export async function initialize(): Promise<void> {
	if (hasInitialized) {
		return;
	}

	if (!Capacitor.isNativePlatform()) {
		hasInitialized = true;
		return;
	}

	await setupStatusBar();
	await setupOrientation();

	hasInitialized = true;
}

/**
 * Setup status bar appearance.
 *
 * @return Promise<void>
 */
async function setupStatusBar(): Promise<void> {
	try {
		await StatusBar.setBackgroundColor({ color: '#2b3544' });
		await StatusBar.hide();
		StatusBar.setOverlaysWebView({ overlay: true });
	} catch (error) {
		ChalkySticks.Utility.Log.error('app', 'Failed to setup status bar:', error);
	}
}

/**
 * Setup orientation handling.
 *
 * @return Promise<void>
 */
async function setupOrientation(): Promise<void> {
	// Placeholder for future orientation logic
}

/**
 * Helper method to unlock orientation.
 *
 * @return Promise<void>
 */
export async function unlockOrientation(): Promise<void> {
	try {
		await ScreenOrientation.unlock();
		const orientation = await ScreenOrientation.orientation();
		ChalkySticks.Utility.Log.info('app', 'Orientation unlocked, current:', orientation.type);
	} catch (error) {
		ChalkySticks.Utility.Log.error('app', 'Failed to unlock orientation:', error);
	}
}
